<template>
  <div>
    <!-- <BreadcrumbBanner
      :pageTitle="$t('Login')"
      :links="[]"
    /> -->
    <!--sign in-->
    <div class="signin-section pt-60 pb-60">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <!--this is log in-->
            <div class="opent-code ss">
              <div class="popup-container">
                <div class="register-from">
                  <div class="head">
                    <h2>{{ $t("Login") }}</h2>
                    <p>{{ $t("Login With Email/Phone") }}</p>
                  </div>
                  <form action="javascript:;" @submit.prevent="onLogin">
                    <div class="items">
                      <div class="form-input">
                        <label for="user_login" class="form-label">{{
                          $t("Enter your email/phone")
                        }}</label>
                        <input
                          type="text"
                          id="user_login"
                          name="user_login"
                          v-model="user_login"
                          :placeholder="$t('Your email/phone')"
                          required
                        />
                      </div>

                      <div class="form-input mt-4">
                        <label for="password" class="form-label">{{
                          $t("Enter your password")
                        }}</label>
                        <input
                          type="password"
                          id="password"
                          name="password"
                          v-model="password"
                          :placeholder="$t('Your password')"
                          required
                        />
                      </div>
                    </div>

                    <div class="items">
                      <button
                        type="submit"
                        class="cmn--btn cd-popup-close repopup"
                      >
                        <span>{{ $t("Login") }}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--sign in-->
  </div>
</template>

<script>
// import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import helpers from "@/helpers";

export default {
  name: "LoginPage",
  components: {
    // BreadcrumbBanner,
  },
  data() {
    return {
      user_login: "",
      password: "",
    };
  },
  computed: {
    ...mapState(useAuthStore, ["isLoggedIn", "userInfo"]),
  },
  methods: {
    ...mapActions(useAuthStore, ["login"]),
    async onLogin() {
      if(!this.user_login) {
        helpers.showToast(
          this.$t("Email/Phone number is required"),
          this.$t("Login Failed"),
          "error"
        );
        return;
      }
      // Add your code here
      await this.login(this.user_login, this.password);
      if (this.isLoggedIn) {
        helpers.showToast(
          this.$t("Login Completed successfully"),
          this.$t("Login Completed"),
          "success"
        );
        const redirectUrl = localStorage.getItem("redirectUrl");
        if (redirectUrl && redirectUrl != "/user/login") {
          this.$router.push(redirectUrl);
        } else {
          this.$router.push({ name: "home" });
        }
      } else {
        let config = helpers.getConfig();
        if(config.subscription_type == "card"){
          helpers.showToast(
            this.$t("You do not have an account, create an account first"),
            this.$t("Login Failed"),
            "error"
          );

          this.$router.push({ name: "user.register" });
        } else {
          window.location.href = config.landing_page_url;
        }
      }
    },
  },
  mounted() {
    // if the user is already logged in, redirect to home page
    if (this.isLoggedIn) {
      this.$router.push({ name: "home" });
    }
  },
};
</script>
